var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('AdminTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }